import type { User } from '@/types/auth';
import { hasPermission, Permission } from './permissions';

export const hasExceptionalTransactionSuccessAccess = (
  user: User | null | undefined,
): boolean => hasPermission(user, Permission.TRANSACTIONS_IN_RESOLVE_SUCCESS);
